<template>
  <v-dialog
    v-model="alertsPopup"
    width="600"
    style="max-width: 600px; overflow-x: hidden"
  >
    <template v-slot:activator="{ on, attrs }">
      <HeaderActionButton v-bind="attrs" v-on="on" :onPressed="onPressed">
        <template v-slot:icon>
          <v-badge
            :value="showAlertBadge"
            color="error"
            right
            overlap
            :content="groupedNotificationCount"
          >
            <v-icon>mdi-bell-outline</v-icon>
          </v-badge>
        </template>
      </HeaderActionButton>
    </template>
    <NotificationDialog :onCancelPressed="onCancelPressed" />
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import NotificationDialog from "@/views/notifications/Dialog.vue";
import HeaderActionButton from "@/views/home/components/HeaderActionButton.vue";
export default {
  name: "NotificationsBadge",
  components: {
    NotificationDialog,
    HeaderActionButton,
  },
  data() {
    return {
      alertsPopup: false,
    };
  },
  computed: {
    ...mapGetters("notifications", ["groupedNotificationCount"]),
    showAlertBadge() {
    return this.groupedNotificationCount > 0;
    },
  },
  mounted() {
  this.$store.dispatch("notifications/fetchNotifications");
  },
  methods: {
    onCancelPressed() {
      this.alertsPopup = false;
    },
    onPressed() {
      this.alertsPopup = true;
    },

  },

};
</script>
